import {collect} from "collect.js";

export default class GenericDataFormatter {

    config = {
        dados: {

        },
        title: '',
        data_label: ''
    };
    headers = [];
    dataCollection = [];


    constructor( data, overlays, config ) {

        this.config = config;

        const enhancedData = data.map( ( datum )=>{
            if (!datum.nome) {
                datum.nome = datum.shape_id
            }

            return datum;
        });

        this.overlays = overlays;
        this.headers = this.getHeaders(enhancedData);

        this.dataCollection = collect(enhancedData).groupBy('nome').all();

        this.config.cityNomes = Object.keys(this.dataCollection).filter(nome => {
            const item = this.dataCollection[nome]?.items?.[0];
            if (!item?.shape_id) return true;
            let shapeId = item.shape_id;
            if (shapeId.startsWith('polygon_')) shapeId = shapeId.replace('polygon_', '');
            const shape = this.overlays.find(o => o.id === shapeId);
            return !shape || shape.type.split(' ')[0] === 'cidade';
        });
    }

    getDatumDisplayName = (datum) => {
        return datum?.nome_poligono
            || datum?.polygon_name
            || datum?.name
            || datum?.nome
            || '';
    }

    getHeaders( data ) {
        let headers = [];

        data.map((datum) => {
            let header = this.getDatumDisplayName(datum);

            if (datum?.shape_id) {
                let shapeId = datum.shape_id;

                if( shapeId.startsWith("polygon_") ){
                    shapeId = shapeId.replace("polygon_","");
                }

                header = this.getShapeName(shapeId, header);
            }

            headers.push(header);
        })

        return headers;
    }

    getShapeName( id, fallbackName = '' ) {
        let shape = this.overlays.find((overlay) => {
            return overlay.id === id;
        });

        if (shape) {

            let shapeType = shape.type.split(' ')[0];
            const shapeName = (shape?.nome ?? shape?.name) != null ? `${shape.nome ?? shape.name}`.trim() : '';

            if (shapeType === 'Polígono' && shapeName) {
                return shapeName;
            }

            if (shapeType !== 'cidade') {
                if (shapeName) {
                    return isNaN(shapeName) ? shapeName : `${shape.type.split(' ')[0]} ${shapeName}`;
                }

                return fallbackName;
            }

            return shapeName || fallbackName;
        }

        return fallbackName;
    }


}
